import React, { useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { Layout } from "../components/layout/Layout";
import { getLocalStorageItem } from "../utils/LocalStorage";
import { useDispatch, useSelector } from "react-redux";
import { recommendationRedux } from "../redux/recommendation-redux/RecommendationRedux";
import { MediaTypeEum } from "../core/enumerations/MediaTypeEnum";
import {
  SDK,
  getAllRegisteredUserInPlatform,
  getRecentChattedUserList,
  getUserMessages,
  getUserProfileDetails,
} from "../services/ChatIndex";
import { chatRedux } from "../redux/chat-redux/ChatRedux";
import { loginRedux } from "../redux/login-redux/LoginRedux";
import { getCookies } from "../utils/Cookies";

const ProtectedRoute = () => {
  const loggedInUser = getLocalStorageItem("token");
  const cachedUserDetails: any = getCookies("userDetails");
  const userDetails: any = cachedUserDetails && JSON.parse(cachedUserDetails);

  const actionDispatch = (dispatch: any) => ({
    setRecommendationState: (data: any) =>
      dispatch(recommendationRedux.actions.setRecommendationState(data)),
    setChatState: (data: any) => dispatch(chatRedux.actions.setChatState(data)),
    destroySessionId: (sessionId: any) =>
      dispatch(
        loginRedux.actions.disconnectAndDestroySessionIdRequest(sessionId)
      ),
    generateSessionIdRequest: (userId: any) =>
      dispatch(loginRedux.actions.generateSessionIdRequest(userId)),
  });

  const {
    setRecommendationState,
    setChatState,
    destroySessionId,
    generateSessionIdRequest,
  } = actionDispatch(useDispatch());

  const recommendationsState = useSelector(
    (state: any) => state?.recommendationRedux
  );

  // useEffect(() => {
  //   const ws = new WebSocket(
  //     `${process.env.REACT_APP_SEKERON_SOCKETS_DATA_STREAMING_URL}?userId=${userDetails?.id}?sessionId=${userDetails?.sessionId}`
  //   );
  //   ws.onopen = (event: any) => { };
  //   ws.onmessage = (event: any) => {
  //     const receivedRecomendedPosts = formatRecomendedData(
  //       JSON.parse(event?.data)?.data
  //     );
  //     setRecommendationState({
  //       key: "recommendedPosts",
  //       value: [
  //         ...receivedRecomendedPosts,
  //         ...recommendationsState?.recommendedPosts,
  //       ],
  //     });
  //     setRecommendationState({
  //       key: "isShowRecommendedPostBatch",
  //       value: true,
  //     });
  //   };
  //   ws.onclose = (event: any) => { };
  //   ws.onerror = (event: any) => { };

  //   window.addEventListener("online", (event: any) => {
  //     const wsWhenComingOnline = new WebSocket(
  //       `${process.env.REACT_APP_SEKERON_SOCKETS_DATA_STREAMING_URL}?userId=${userDetails?.id}?sessionId=${userDetails?.sessionId}`
  //     );

  //     wsWhenComingOnline.onopen = (event: any) => { };
  //     wsWhenComingOnline.onmessage = (event: any) => {
  //       const receivedRecomendedPosts = formatRecomendedData(
  //         JSON.parse(event?.data)?.data
  //       );
  //       setRecommendationState({
  //         key: "recommendedPosts",
  //         value: [
  //           ...receivedRecomendedPosts,
  //           ...recommendationsState?.recommendedPosts,
  //         ],
  //       });
  //       setRecommendationState({
  //         key: "isShowRecommendedPostBatch",
  //         value: true,
  //       });
  //     };
  //     wsWhenComingOnline.onclose = (event: any) => { };
  //     wsWhenComingOnline.onerror = (event: any) => { };
  //     window.addEventListener("offline", (event: any) => {
  //       wsWhenComingOnline.close();
  //       // destroySessionId(userDetails?.sessonId);
  //       return () => {
  //         window.removeEventListener("offline", () => { });
  //         wsWhenComingOnline.close();
  //         // destroySessionId(userDetails?.sessonId);
  //       };
  //     });

  //     // ///////
  //     // newwww code for inactive
  //     let inactiveTime = 0;
  //     const maxInactiveTime = 1000 * 60 * 60; // 2hrs in milliseconds

  //     function resetInactiveTime() {
  //       inactiveTime = 0;
  //     }

  //     function checkInactiveTime() {
  //       inactiveTime += 1000; // assuming you check every second
  //       if (inactiveTime === maxInactiveTime) {
  //         ws.close();
  //         // destroySessionId(userDetails?.sessonId);
  //         wsWhenComingOnline.close();
  //       } else if (inactiveTime === 0) {
  //       }
  //     }
  //     document.addEventListener("mousemove", (event) => {
  //       resetInactiveTime();
  //     });
  //     const screenTimer = setInterval(checkInactiveTime, 1000);

  //     // //////
  //     return () => {
  //       window.removeEventListener("online", () => { });
  //       wsWhenComingOnline.close();
  //       // destroySessionId(userDetails?.sessonId);
  //       clearInterval(screenTimer);
  //     };
  //   });

  //   window.addEventListener("offline", (event: any) => {
  //     ws.close();
  //     // destroySessionId(userDetails?.sessonId);
  //     return () => {
  //       window.removeEventListener("offline", () => { });
  //       ws.close();
  //       // destroySessionId(userDetails?.sessonId);
  //     };
  //   });

  //   let inactiveTime = 0;
  //   const maxInactiveTime = 1000 * 60 * 60; // 2hrs in milliseconds

  //   function resetInactiveTime() {
  //     inactiveTime = 0;
  //   }

  //   function checkInactiveTime() {
  //     inactiveTime += 1000; // assuming you check every second
  //     if (inactiveTime === maxInactiveTime) {
  //       ws.close();
  //       // destroySessionId(userDetails?.sessonId);
  //     } else if (inactiveTime === 0) {
  //     }
  //   }
  //   document.addEventListener("mousemove", (event) => {
  //     resetInactiveTime();
  //   });
  //   const screenTimer = setInterval(checkInactiveTime, 1000);

  //   return () => {
  //     ws.close();
  //     // destroySessionId(userDetails?.sessonId);
  //     clearInterval(screenTimer);
  //   };
  // }, []);

  useEffect(() => {
    initializeSDK();
    return () => { };
  }, []);

  const formatRecomendedData = (posts: any) => {
    return posts?.map((post: any) => {
      return {
        ...post,
        postMedias: post?.postMedias?.map((media: any) => {
          if (
            post?.mediaType === MediaTypeEum.audio ||
            post?.mediaType === MediaTypeEum.voice ||
            post?.mediaType === MediaTypeEum.video
          ) {
            return {
              ...media,
              isPlaying: false,
              isMute: false,
            };
          } else {
            return media;
          }
        }),
      };
    });
  };

  const connectionListeners = (response: any) => {
    if (response.status === "CONNECTED") {
    } else if (response.status === "DISCONNECTED") {
    } else if (response.status === "CONNECTIONFAILED") {
    } else if (response.status === "RECONNECTING") {
    }
  };

  const presenceListener = (res: any) => {
    // console.log("chat listener presenceListener", res);
  };
  const friendsListListener = (res: any) => {
    // console.log("chat listener friendsListListener", res);
  };
  const userProfileListener = (res: any) => {
    // console.log("chat listener userProfileListener", res);
  };
  const messageListener = async (res: any) => {
    console.log("chat listener messageListener", res);
    switch (res?.msgType) {
      case "receiveMessage":
        updateRecentChatUserList(res);
        if (res?.chatType === "groupchat") {
          getUserChatMessages(res?.fromUserJid);
        }
        break;
      case "clearChat":
        break;
      case "acknowledge":
        if (res?.type === "acknowledge") {
          updateRecentChatUserList(res);
          // getUserChatMessages(res?.fromUserJid);
          setChatState({
            key: "selectedChatIndex",
            value: 0,
          });
        }
        break;
      // case "delivered":
      //   if (res?.msgType === "delivered") {
      //     updateRecentChatUserList(res);
      //     // getUserChatMessages(res?.fromUserJid);
      //     setChatState({
      //       key: "selectedChatIndex",
      //       value: 0,
      //     });
      //   }
      //   break;
      case "seen":
        if (res?.msgType === "seen") {
          updateRecentChatUserList(res);
          // getUserChatMessages(res?.fromUserJid);
          // setChatState({
          //   key: "selectedChatIndex",
          //   value: 0,
          // });
        }
        break;
    }
  };
  const replyMessageListener = (res: any) => {
    // console.log("chat listener replyMessageListener", res);
  };
  const favouriteMessageListener = (res: any) => {
    // console.log("chat listener favouriteMessageListener", res);
  };
  const groupProfileListener = (res: any) => {
    // console.log("chat listener groupProfileListener", res);
    switch (res?.msgType) {
      case "profileUpdated":
        updateRecentChatUserList();
        break;
      case "userAdded":
        updateRecentChatUserList();
        break;
    }
  };
  const groupMsgInfoListener = (res: any) => {
    // console.log("chat listener groupMsgInfoListener", res);
  };
  const mediaUploadListener = (res: any) => { };
  const mediaDownloadListener = (res: any) => { };
  const blockUserListener = (res: any) => { };
  const singleMessageDataListener = (res: any) => { };
  const muteChatListener = (res: any) => {
    // console.log("chat listener muteChatListener", res);
  };
  const archiveChatListener = (res: any) => { };
  const userDeletedListener = (res: any) => { };
  const adminBlockListener = (res: any) => { };

  const initializeSDK = async () => {
    const initializeObj = {
      licenseKey: "Q7njxET7AGU9oCfYbM4CD3UFbdMI9B",
      callbackListeners: {
        connectionListeners,
        presenceListener,
        friendsListListener,
        userProfileListener,
        messageListener,
        replyMessageListener,
        favouriteMessageListener,
        groupProfileListener,
        groupMsgInfoListener,
        mediaUploadListener,
        mediaDownloadListener,
        blockUserListener,
        singleMessageDataListener,
        muteChatListener,
        archiveChatListener,
        userDeletedListener,
        adminBlockListener,
      },
    };
    const response: any = await SDK.initializeSDK(initializeObj);
    if (response?.statusCode === 200) {
      regsterUser(userDetails?.id);
    }
  };

  const regsterUser = async (userId: any) => {
    const response: any = await SDK.register(userId, true);
    if (response.statusCode === 200) {
      console.log(response?.data, "response?.data-register")
      setChatState({ key: "chatRegisteredDetails", value: response?.data });
      connectChatUser(response?.data?.username, response?.data?.password);
    }
  };

  const connectChatUser = async (username: any, password: any) => {
    const response: any = await SDK.connect(username, password);
    if (response?.statusCode === 200) {
      const getToken: any = await getUserToken(username, password);
      if (getToken?.statusCode === 200) {
        const setTokenResponse: any = await SDK.setUserToken(
          getToken?.userToken
        );
        const profileDetailsResponse: any = await getUserProfileDetails(
          username
        );
        // console.log(profileDetailsResponse, "profileDetailsResponse")
        updateRecentChatUserList();
        if (setTokenResponse?.statusCode === 200) {
          if (profileDetailsResponse?.nickName === "") {
            const updateProfileDataResponse = await updateProfileDetails();
            // console.log(updateProfileDataResponse, "updateProfileDataResponse")
          }
          const registeredUserResponse: any =
            await getAllRegisteredUserInPlatform();
          if (registeredUserResponse?.statusCode === 200) {
            setChatState({
              key: "registeredUsersList",
              value: registeredUserResponse?.users,
            });
          }
        }
      }
    }
  };

  const updateProfileDetails = async () => {
    const response: any = await SDK.setUserProfile(
      userDetails?.fullName,
      // userDetails?.profilePic,
      "Active",
      // userDetails?.phoneNumber,
      // userDetails?.email
    );
    return response;
  };

  const updateRecentChatUserList = async (responseListener?: any) => {
    const recentChatList: any = await getRecentChattedUserList();
    // console.log(recentChatList, "recentChatList")
    if (recentChatList?.statusCode === 200) {
      const fetchUserProfileDetails = async (userId: any) => {
        const response = await getUserProfileDetails(userId);
        return response;
      };
      const promses: any = [];
      recentChatList?.data?.forEach((user: any) => {
        promses.push(fetchUserProfileDetails(user?.fromUserId));
      });
      Promise.allSettled(promses).then((res: any) => {
        const presentTime = new Date();
        const chatList: any = recentChatList?.data?.map(
          (user: any, index: any) =>
            res[index]?.value?.userId === responseListener?.fromUserId
              ? {
                ...user,
                profileDetails: res[index]?.value,
                isReceivedNewMessage: true,
                isLastMessageSentByMe: false,
                msgBody: {
                  ...responseListener?.msgBody,
                  msgReceivedTime: presentTime,
                },
              }
              : { ...user, profileDetails: res[index]?.value }
        );
        const filteredData = chatList?.filter(
          (a: any) => a?.profileDetails !== undefined
        );
        // console.log(chatList, "chatList")
        if (chatList && chatList?.length > 0 && chatList?.some((item) => item?.unreadCount > 0)) {
          // console.log("unReadCount - true")
          setChatState({
            key: "unreadMessages",
            value: true,
          });
        }
        else {
          // console.log("unReadCount - false")
          setChatState({
            key: "unreadMessages",
            value: false,
          });
        }
        setChatState({
          key: "chatUsersList",
          value: filteredData?.reverse(),
        });
      });
    }
  };

  const getUserToken = async (username: any, password: any) => {
    const response: any = await SDK.getUserToken(username, password);
    return response;
  };

  const getUserChatMessages = async (userJid: any) => {
    const response: any = await getUserMessages(userJid);
    // console.log(response, "linee399")
    if (response?.statusCode === 200) {
      const data: any = response?.data?.reverse();
      setChatState({
        key: "selectedUserChatList",
        value: data,
      });
    }
    return;
  };

  return loggedInUser ? (
    <Layout>
      <Outlet />
    </Layout>
  ) : (
    <Navigate to="/" />
  );
};

export default ProtectedRoute;
